import React from 'react';

import jsdom from 'jsdom'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { getClient } from '@api/feedStream';
import { SocialAPI } from '@api/index';
import I18n from '@utils/i18n';
import { getRecommendStory } from '@utils/news';
import { isValidSource } from '@utils/sundries'
import {
  DetailLayout,
  NextPost,
  PostComments,
  PostContent,
  PostLike,
  usePostComments,
  usePostLike
} from '@widget/news';

const T = (props) => {
  const { recommend, post, prevPost, nextPost } = props;
  const postLikeProps = usePostLike({
    isLoved: post?.result?.like,
    likeCount: post?.result?.likeCount,
    postData: post?.result,
    id: post?.result?.id
  });
  const commentsProps = usePostComments({
    commentCount: post?.result?.commentCount,
    id: post?.result?.id
  });
  const { query } = useRouter()
  return (
    <DetailLayout
      {...postLikeProps}
      {...commentsProps}
      recommend={recommend}
      post={{ ...post?.result, images: post?.result?.images?.filter(src => isValidSource(src, 'image')) || [] }}
      asideTag={{ moduleTitle: 'p', postTitle: 'h2' }}
    >
      <Head>
        <title>{I18n.t('information_t', { title: props?.post?.result?.title })}</title>
        <meta property="og:title" content={props.des} key="title" name="description"/>
      </Head>
      <PostContent html={post?.result?.text} />
      {!query.type && <NextPost desc={I18n.t('zgKiw1lL')} title={prevPost?.title} id={prevPost?.viewId}/>}
      {!query.type && <NextPost desc={I18n.t('lwX6dZJ9')} title={nextPost?.title} id={nextPost?.viewId}/>}
      <PostLike {...postLikeProps} />
      <PostComments
        {...commentsProps}
        nextId={post?.nextId}
        postData={post?.result}
      />
    </DetailLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  const { userId, jwt, zone } = ctx.req.cookies || {};
  const { id } = ctx.params;
  const feedParamUser = 'post';
  const feedParamType = userId || 'square';
  const props = {};
  try {
    const [
      { value: recommend },
      { value: post },
      { value: prevPost },
      { value: nextPost }
    ] = await Promise.allSettled([
      getRecommendStory({ limit: 6, language: ctx.locale, zone: zone }),
      getClient(jwt)
        .feed(feedParamUser, feedParamType)
        .get({ id_lte: id, id_gte: id }),
      SocialAPI.getNextPost({
        id_lte: id,
        id_gte: id,
        forward: true,
        limit: 1
      }),
      SocialAPI.getNextPost({
        id_lte: id,
        id_gte: id,
        forward: false,
        limit: 1
      })
    ]);
    props.recommend = recommend || {};
    props.post = post || {};
    props.prevPost = prevPost?.result?.res?.[0] || {};
    props.nextPost = nextPost?.result?.res?.[0] || {};
  } catch (error) {
    console.log('line 30', error);
  }
  const { JSDOM } = jsdom;
  const text = props.post?.result?.text
  if (text) {
    const dom = new JSDOM(`<!DOCTYPE html><div id='contain'>${text}</div>`);
    const textContent = dom.window.document.getElementById('contain').textContent
    props.des = textContent.slice(0, 319)
  }
  return { props };
};

export default T;
